import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';
import { orpcClient } from '@/lib/api/orpc/client';
import type { ExportSoftwareAlertsRequest, ExportSoftwareAlertsResponse, ListSoftwareAlertsUsersRequest, ListSoftwareAlertsUsersResponse, SoftwareAlertCounts } from './type';
export async function getSoftwareAlertCounts(): Promise<SoftwareAlertCounts> {
  const res = await apiClient.GET('/v2/app-alerts/count', {
    params: {}
  });
  const data = getDataOrThrowApiError(res);
  return {
    noWorker: data?.NO_WORKER ?? 0,
    violatedAssignment: data?.VIOLATED ?? 0,
    violatedRole: data?.VIOLATED_ROLE ?? 0,
    noUser: data?.NO_USER ?? 0,
    inactive: data?.INACTIVE ?? 0,
    alumni: data?.ALUMNI ?? 0
  };
}
export async function listSoftwareAlertsUsers(params: ListSoftwareAlertsUsersRequest): Promise<ListSoftwareAlertsUsersResponse> {
  const res = await apiClient.GET('/v2/app-alerts/users', {
    params: {
      query: params
    }
  });
  return getDataOrThrowApiError(res);
}
export async function exportSoftwareAlerts(params: ExportSoftwareAlertsRequest): Promise<ExportSoftwareAlertsResponse> {
  const res = await apiClient.GET('/v2/app-alerts-csv', {
    params: {
      query: {
        ...params,
        mode: 'view',
        encoding: 'UTF-8'
      }
    }
  });
  return getDataOrThrowApiError(res);
}

// 組織配下の全連携の定期同期を 30 分以内へ分散して前倒し re-schedule する（即時実行はしない）。
// 旧 refreshResourcesAll（即時 fan-out）の置き換え。応答は予約サマリ。
export async function postRefreshResourcesAll() {
  return await orpcClient.software.integrationRefreshResourcesAll({});
}